import React from 'react'
import { Link } from 'react-router-dom';
import { useSyncedStore } from '@syncedstore/react';

import { todoStore } from 'src/store/todo';
import { checkForDuplicates } from 'src/utils/duplicates';

import Container from '../shared/container';
import TeamCard from '../shared/cards/team';
import Fallback from '../shared/fallback';

const Teams: React.FC = () => {
    const state = useSyncedStore(todoStore);

    const teams = state.teams || [];
    const workers = state.workers || [];

    // Check for duplicates and warn
    React.useEffect(() => {
        checkForDuplicates(teams, 'Teams')
        checkForDuplicates(workers, 'Workers')
    }, [teams.length, workers.length])

    const getWorkerCount = (teamId: string) => {
        return workers.filter(w => w.teamId === teamId && w.isActive).length;
    };

    const getWorkersOutCount = (id: string) => {
        const workersOut = state.workerOuts.filter(w =>
            w.teamId === id && !w.softDeleted
        );
        if (workersOut.length > 0) {
            return workersOut.length;
        }

        return 0;
    }

    const getWorkersWithAssignmentsCount = (teamId: string) => {
        const teamWorkers = workers.filter(w => w.teamId === teamId && w.isActive);
        const workersWithAssignments = teamWorkers.filter(worker => {
            const hasAssignment = state.workerAssignments.some(a =>
                a.workerId === worker.id && !a.softDeleted
            );
            return hasAssignment;
        });
        return workersWithAssignments.length;
    }

    return (
        <Container>
            <div className='flex flex-col gap-2 w-full pt pb-20'>
                {teams.length > 0 ?
                    (teams.map((t) => (
                        <Link key={t.id} to={`/team/${t.id}?name=${t.teamName}`}>
                            <TeamCard
                                title={t.teamName}
                                description={t.teamDescription}
                                workersOutCount={getWorkersOutCount(t.id)}
                                workersWithAssignmentsCount={getWorkersWithAssignmentsCount(t.id)}
                                count={`${getWorkerCount(t.id)}`} />
                        </Link>
                    ))) : <Fallback title='No team found!' />
                }
            </div>
        </Container>
    )
}

export default Teams
